import {SketchRelationDefinition,} from './SketchRelationDefinition';
import type {ISketchObject} from '../../../../mesh/sketch/ISketchObject';


/**
 * 单目标约束抽象基类。
 * 职责：
 * 1. 关系实例维护一个公式目标；
 * 2. 目标集合由领域容器绑定，关系对象不执行求解。
 */
export function isSingleTargetRelation(value: object): value is SingleTargetRelation<any> {
    return Reflect.get(value, "isSingleTargetRelation") === true;
}
export abstract class SingleTargetRelation<T extends ISketchObject> extends SketchRelationDefinition<T> {
    readonly isSingleTargetRelation: boolean = true;

}


